import React, { ReactNode } from "react";
import { Button, ButtonProps } from "@mui/material";

export function InlineFormButton({
  children,
  ...props
}: {
  children: ReactNode;
} & ButtonProps) {
  return (
    <Button className={"inline-button"} color={"info"} disableElevation variant={"contained"} {...props}>
      {children}
    </Button>
  );
}
